export enum RoleNormalizedName {
  ACCOUNT_REVIEWER = 'AccountReviewer', //INTERNO
  ADMIN = 'Admin', //INTERNO
  CUSTOMER_SERVICE = 'CustomerService', //INTERNO
  ECI_IMPLANT = 'EciImplant', //INTERNO
  IMPLANT = 'Implant', //INTERNO
  NONE = 'None', //INTERNO
  TECHNICAL = 'Technical', //INTERNO
  ACCOUNT_MANAGER = 'AccountManager', //EXTERNO
  REPORT_MANAGER = 'ReportManager', //EXTERNO
  REPORT_READER = 'ReportReader', //EXTERNO
}
